module.exports = __webpack_public_path__ + "assets/img/tabs1.f7d9ae64.png";